/**
 * Optional runtime fetch shim.
 *
 * When `VITE_API_BASE_URL` is set at build/dev time, we monkey-patch the
 * global `fetch` so any relative request starting with `/api/…` is rewritten
 * to `${VITE_API_BASE_URL}/api/…`. This lets every existing
 * `fetch("/api/generate", …)` call site continue to work unchanged when the
 * SPA is served from a different origin than the API.
 *
 * In dev, leave VITE_API_BASE_URL empty so the Vite proxy forwards /api/*
 * to the Fastify backend (see vite.config.ts).
 */
const BASE = (import.meta.env.VITE_API_BASE_URL ?? "")
  .trim()
  .replace(/\/$/, "");

if (BASE && typeof window !== "undefined") {
  const original = window.fetch.bind(window);

  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === "string" && input.startsWith("/api/")) {
      return original(BASE + input, init);
    }
    if (input instanceof URL && input.pathname.startsWith("/api/") && !input.host) {
      return original(BASE + input.pathname + input.search, init);
    }
    if (input instanceof Request && new URL(input.url, window.location.href).pathname.startsWith("/api/")) {
      const u = new URL(input.url, window.location.href);
      if (u.origin === window.location.origin) {
        const rewritten = new Request(BASE + u.pathname + u.search, input);
        return original(rewritten, init);
      }
    }
    return original(input, init);
  };
}

export {};
